import React from "react";
import "../src/scss/App.scss";
import "@progress/kendo-theme-default/dist/all.scss";
import socketIOClient from "socket.io-client";
import Routes from "./routes";
import { NotificationToaster } from "./components/notificationToaster";
import projectSetting from "./setting";
import { getUserCredential } from "./lib/cookies";
//import { DbObjectService } from "./service/dbObject";
import UnSavedChangePopup from "./components/UnsavedChangePopup";
import MaintenanceMsg from "./pages/common/maintenanceMsg";
import { PendoHook } from "src/components/pendo/script.hook";
import { getUnreadCount } from "./pages/messages/service/getMessages";
import { changeMessageCount } from "./redux/actions/setting-actions";
import { useDispatch } from "react-redux";

const ENDPOINT = projectSetting.socket_url;

export let socket = socketIOClient.connect(ENDPOINT, {
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: 5,
  transports: ["websocket"],
  forceNode: true,
});

//  // Listen for messages from the server
// socket.on('message', (data) => {
// });
//    socket.on('connect', (param) => {
//     socket.removeAllListeners();

//    });
//    socket.on('disconnect', (reason) => {
//     socket.removeAllListeners();
//      socket = null
//    });
//    socket.on('reconnect', (reason) => {
//   });

function App() {
  const cookiesData = getUserCredential();
  const pendoHook = PendoHook();
  const dispatch = useDispatch();

  React.useEffect(async () => {
    if (cookiesData) {
      pendoHook.renderScript();

      // Fetch unread count after login success
      const unreadCountData = await getUnreadCount(cookiesData, dispatch);
      if (Array.isArray(unreadCountData) && unreadCountData.length > 0) {
        const totalUnreadCount = unreadCountData[0]?.total_unread_count || 0;
        dispatch(changeMessageCount(totalUnreadCount));
      }
    }
  }, [cookiesData, dispatch, pendoHook]);

  return (
    <div className="App">
      <div>
        <MaintenanceMsg />
        <Routes />
        <NotificationToaster />
        <UnSavedChangePopup />
      </div>
    </div>
  );
}

export default App;
